import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import type { RouteWaypointLabelProps } from './types';

/** HTML label on waypoint vertices only (not mid-edge — those use polyline insert handles). */
/** Same visual size as destination pin head (`destination-pending.svg`, 24px). */
const ROUTE_WAYPOINT_SIZE_PX = 24;
const ROUTE_WAYPOINT_COLOR = '#9664F8';

const RouteWaypointLabel: React.FC<RouteWaypointLabelProps> = ({ position, waypointNumber }) => {
  const fontSize = waypointNumber >= 10 ? 10 : 11;

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.FLOAT_PANE}>
      <div
        style={{
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          width: ROUTE_WAYPOINT_SIZE_PX,
          height: ROUTE_WAYPOINT_SIZE_PX,
          boxSizing: 'border-box',
          borderRadius: '50%',
          border: `2px solid ${ROUTE_WAYPOINT_COLOR}`,
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          color: ROUTE_WAYPOINT_COLOR,
          fontSize,
          fontWeight: 700,
          fontFamily: 'system-ui, Segoe UI, Roboto, sans-serif',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          userSelect: 'none',
          lineHeight: 1,
          zIndex: 2_000_000,
        }}>
        {waypointNumber}
      </div>
    </OverlayView>
  );
};

export default RouteWaypointLabel;
